<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="10" :lg="11" :md="12" :sm="24">
            <a-form-item label="创建日期">
              <j-date :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" placeholder="请选择开始时间" class="query-group-cust" v-model="queryParam.createTime_begin"></j-date>
              <span class="query-group-split-cust"></span>
              <j-date :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" placeholder="请选择结束时间" class="query-group-cust" v-model="queryParam.createTime_end"></j-date>
            </a-form-item>
          </a-col>
           <a-col :xl="3" :lg="4" :md="5" :sm="12">
              <a-form-item label="报修人">
                <a-input placeholder="请输入报修人" v-model="queryParam.bxAccount"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="3" :lg="4" :md="5" :sm="12">
              <a-form-item label="接单员">
                <a-input placeholder="请输入接单员" v-model="queryParam.wxAccount"></a-input>
              </a-form-item>
               </a-col>
            <a-col :xl="3" :lg="4" :md="5" :sm="12">
              <a-form-item label="报修科室">
                <a-input placeholder="请输入接单员" v-model="queryParam.departName"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('报修申请表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a  v-if="record.status == 0" @click="handleChuli(record)">处理</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <bx-order-modal ref="modalForm" @ok="modalFormOk"></bx-order-modal>
  </a-card>
</template>

<script>
  import { getAction, deleteAction, putAction, postAction, httpAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BxOrderModal from './modules/BxOrderModal'
  import JDate from '@/components/jeecg/JDate.vue'

  export default {
    name: 'BxOrderList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JDate,
      BxOrderModal
    },
    data () {
      return {
        description: '报修申请表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'报修科室',
            align:"center",
            dataIndex: 'departName'
          },
          {
            title:'报修时间',
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title:'开始时间',
            align:"center",
            dataIndex: 'jiedanTime'
          },
          {
            title:'完成时间',
            align:"center",
            dataIndex: 'wanChengTime'
          },
          {
            title:'接单员',
            align:"center",
            dataIndex: 'wxAccount'
          },
          {
            title:'报修人',
            align:"center",
            dataIndex: 'bxAccount'
          },
          {
            title:'手机号',
            align:"center",
            dataIndex: 'phone'
          },
          {
            title:'身份类型',
            align:"center",
            dataIndex: 'role'
          },
          {
            title:'故障位置',
            align:"center",
            dataIndex: 'bxAddress'
          },
          {
            title:'报修描述',
            align:"center",
            dataIndex: 'bxDescription'
          },
          {
            title:'故障照片',
            align:"center",
            dataIndex: 'bxSrc',
            scopedSlots: {customRender: 'imgSlot'}
          },

          {
            title:'报修材料用量',
            align:"center",
            dataIndex: 'skuNames'
          },
            {
              title:'所用材料费用',
              align:"center",
              dataIndex: 'ortherAmout'
            },
          {
            title:'状态展示',
            align:"center",
            dataIndex: 'statusShow'
          },
          {
            title:'评价',
            align:"center",
            dataIndex: 'evaluation'
          },
         {
            title:'满意度',
            align:"center",
            dataIndex: 'evaluationPf'
          },{
            title:'维修时长',
            align:"center",
            dataIndex: 'times'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/bxOrder/list",
          delete: "/bxOrder/delete",
          deleteBatch: "/bxOrder/deleteBatch",
          exportXlsUrl: "/bxOrder/exportXls",
          importExcelUrl: "bxOrder/importExcel",
          chuli:'/bxOrder/edit'
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      handleChuli(data){
        console.log('data',data);
        let params = {
          id:data.id,
          status:1,
          statusShow:'待评价'
        }
        putAction(this.url.chuli,params).then((res)=>{
          console.log('res',res);
            if(res.success){
              this.$router.go(0)
            }
          });
      },
      initDictConfig(){
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>